import { render, staticRenderFns } from "./BiddingAgentExpansionCard.vue?vue&type=template&id=5677d7da&scoped=true"
import script from "./BiddingAgentExpansionCard.vue?vue&type=script&lang=js"
export * from "./BiddingAgentExpansionCard.vue?vue&type=script&lang=js"
import style0 from "./BiddingAgentExpansionCard.vue?vue&type=style&index=0&id=5677d7da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5677d7da",
  null
  
)

export default component.exports